/** SCRIPTS */
const swiperClientes = new Swiper('#swiper-clientes', {
    allowTouchMove: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    speed: 3000,
    autoplay: {
        delay: 0,
    }
});


const swiperDepoimentos = new Swiper('#swiper-depoimentos', {
    autoHeight: true,
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 5000,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))